var map = {
	"./cork-based-material/safety.pdf": [
		5888,
		5888
	],
	"./recycled-paper-boards/safety.pdf": [
		8201,
		8201
	],
	"./recycled-paper-composite/safety.pdf": [
		5629,
		5629
	],
	"./recycled-paper-panel/safety.pdf": [
		364,
		364
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7303;
module.exports = webpackAsyncContext;